import { render, staticRenderFns } from "./Corporativos.vue?vue&type=template&id=6fb0a987"
import script from "./Corporativos.vue?vue&type=script&lang=js"
export * from "./Corporativos.vue?vue&type=script&lang=js"
import style0 from "./Corporativos.vue?vue&type=style&index=0&id=6fb0a987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports